var topicQuickPath = {
		"watch": function(){
			$("#main-3").click()
			setTimeout(function(){
				$("#prediction_type").val("afternoon_rain").trigger("change")
				$("#prediction_afternoon_rain_trig").click()
			}, 1000)
		},
		"earthquake": function(){
			setTimeout(function(){
				$("#t_earthquake").click()
			})
		},
		"rainfall_forecasting": function(){
			$("#main-3").click()
			setTimeout(function(){
				$("#prediction_type").val("ai_rain").trigger("change")
			}, 1000)
		},
		"roadflood_forecasting": function(){
			$("#main-3").click()
			setTimeout(function(){
				$("#prediction_type").val("roadflood").trigger("change")
			}, 1000)
		},
		"flooding_sensor": function(){
			setTimeout(function(){
				$("#t_flood_sensor").click()
			})
		}
	},
	regionTID = {
		"石門區": "001", "三芝區": "002", "金山區": "003", "淡水區": "004", "萬里區": "005",
		"八里區": "009", "汐止區": "014", "林口區": "016", "五股區": "017", "瑞芳區": "018",
		"蘆洲區": "023", "雙溪區": "024", "三重區": "025", "貢寮區": "027", "平溪區": "029",
		"新莊區": "033", "石碇區": "040", "板橋區": "041", "深坑區": "044", "永和區": "045",
		"樹林區": "046", "中和區": "048", "土城區": "049", "新店區": "050", "坪林區": "053",
		"鶯歌區": "054", "三峽區": "057", "烏來區": "061", "泰山區": "062"
	},
	board_make_conditon = false,
	emis_event_select = false,
	wmsQueryTargetList = [],
	eoc_advice_updater = {action: false},
	overlay_dataset = {},
	raw_data = {},
	user_device = navigator.userAgent,
	// isMobile = (user_device.match("Android") || user_device.match("iPhone")),
	isMobile = $(window).width() < 450,
	isiOS = (user_device.match("iPad") || user_device.match("iPhone")),
	trigger_method = isiOS ? "onmouseover" : "click",
	user_unit_name = localStorage.getItem('user_unit_name'),
	disable_map_clear = false,
	dangerous_buildings_filter = {}, chemicals_filter = {},
	cctv_render_list = JSON.parse(localStorage.getItem('cctv_render_list')) ?? []

loader_animation_control(true)

$(document).ready(function(){
	loader_animation_control(false);
	// 前往倉儲ETL & Swagger頁面
	$("body").on("click", "#t_swagger, #t_edpw_obs", function(){
		let jwt_token_swagger = localStorage.getItem('jwt_token_swagger'),
			path_mapping = {
				"t_swagger": {
					url: "swagger",
					name: "Swagger文件"
				},
				"t_edpw_obs": {
					url: "DataMonitor",
					name: "資料監控平臺"
				}
			},
			this_path = path_mapping[$(this).attr("id")]
		if (jwt_token_swagger) {
			$("#other-system-container").html(`
				<form class="d-none" target="_blank" id="form1" action="https://www.edp-dws.ntpc.gov.tw/edpw/${this_path.url}" method="POST">
					<input type="hidden" name="token" value="${jwt_token_swagger}" />
				</form>`
			)
			toast_open("將前往至「" + this_path.name + "」！")
			setTimeout(function(){
				$('#form1').submit()
			}, 1000)
		} else {
			loader_asynchronous(function(){
				$.ajax({
					url: publicPath + '/napi/swagger_token',
					method: 'GET',
					async: false,
					headers: {
						Authorization: 'Bearer ' + jwt_token
					}
				}).done(function(res) {
					$("#other-system-container").html(`
						<form class="d-none" target="_blank" id="form1" action="https://www.edp-dws.ntpc.gov.tw/edpw/${this_path.url}" method="POST">
							<input type="hidden" name="token" value="${res.data}" />
						</form>`
					)
					toast_open("將前往至「" + this_path.name + "」！")
					setTimeout(function(){
						$('#form1').submit()
					}, 1000)
					localStorage.setItem('jwt_token_swagger', res['data'])
				})
			})
		}
	})
	// 初始資料設定
	raw_data["wrs_gate_basic"] = [
		{"Gate_No":"G1","NAME_C":"中正橫移門","NAME_E":null,"ADDR_C":"永和區環河東路一段及光復街口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.515336,"LAT_DEC":25.018031,"BASIN_NAME":"新店溪"},{"Gate_No":"G10","NAME_C":"利濟橫移門","NAME_E":null,"ADDR_C":"新莊區環河路及利濟街口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.453214,"LAT_DEC":25.033632,"BASIN_NAME":"大漢溪"},{"Gate_No":"G100","NAME_C":"塔寮坑橫移門","NAME_E":null,"ADDR_C":"新莊區環河路、瓊林路及利濟街口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.447002,"LAT_DEC":25.028983,"BASIN_NAME":"塔寮坑溪"},{"Gate_No":"G11","NAME_C":"福和橫移門","NAME_E":null,"ADDR_C":"永和區環河東路三段及成功路一段交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.52743,"LAT_DEC":25.005608,"BASIN_NAME":"新店溪"},{"Gate_No":"G12","NAME_C":"世新三橫移門","NAME_E":null,"ADDR_C":"新店區寶元路1段1號對面","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.541963,"LAT_DEC":24.987556,"BASIN_NAME":"景美溪"},{"Gate_No":"G13","NAME_C":"大鵬橫移門","NAME_E":null,"ADDR_C":"新店區水源快速道路新店端下","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.534388,"LAT_DEC":24.993492,"BASIN_NAME":"景美溪"},{"Gate_No":"G14","NAME_C":"大鵬二橫移門","NAME_E":null,"ADDR_C":"新店區環河路及景文街146巷交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.532191,"LAT_DEC":24.990643,"BASIN_NAME":"景美溪"},{"Gate_No":"G15","NAME_C":"成功街橫移門","NAME_E":null,"ADDR_C":"土城區環河道路及成功街口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.425584,"LAT_DEC":24.967942,"BASIN_NAME":"大漢溪"},{"Gate_No":"G16","NAME_C":"白馬寺水門","NAME_E":null,"ADDR_C":"新店區環河路182號","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.536874,"LAT_DEC":24.964188,"BASIN_NAME":"景美溪"},{"Gate_No":"G2","NAME_C":"永福橫移門","NAME_E":null,"ADDR_C":"永和區環河東路二段及豫溪街交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.52408,"LAT_DEC":25.010487,"BASIN_NAME":"新店溪"},{"Gate_No":"G3","NAME_C":"永和橫移門","NAME_E":null,"ADDR_C":"永和區環河西路二段及保生路口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.504535,"LAT_DEC":25.013034,"BASIN_NAME":"新店溪"},{"Gate_No":"G4","NAME_C":"江子翠橫移門","NAME_E":null,"ADDR_C":"板橋區環河道路","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.483587,"LAT_DEC":25.027945,"BASIN_NAME":"新店溪"},{"Gate_No":"G5","NAME_C":"光復橫移門","NAME_E":null,"ADDR_C":"板橋區環河道路及光復街172巷交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.486588,"LAT_DEC":25.019115,"BASIN_NAME":"新店溪"},{"Gate_No":"G6","NAME_C":"華江橫移門","NAME_E":null,"ADDR_C":"板橋區環河道路","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.470423,"LAT_DEC":25.036354,"BASIN_NAME":"大漢溪"},{"Gate_No":"G7","NAME_C":"新海橫移門","NAME_E":null,"ADDR_C":"板橋區環河道路","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.456175,"LAT_DEC":25.029267,"BASIN_NAME":"大漢溪"},{"Gate_No":"G8","NAME_C":"湳仔溝橫移門","NAME_E":null,"ADDR_C":"板橋區環河道路","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.446972,"LAT_DEC":25.020425,"BASIN_NAME":"大漢溪"},{"Gate_No":"G9","NAME_C":"西盛橫移門","NAME_E":null,"ADDR_C":"新莊區環河路及環河路2巷交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.435339,"LAT_DEC":25.000547,"BASIN_NAME":"大漢溪"},{"Gate_No":"G17","NAME_C":"浮洲橫移門","NAME_E":null,"ADDR_C":"板橋區大觀路二段及環河西路五段交叉口","ADDR_E":null,"TM_X":null,"TM_Y":null,"LON_DEC":121.440996,"LAT_DEC":24.9985,"BASIN_NAME":"大漢溪"}
	];
	// overlay_dataset["Basic_map"] = NTC_map();

	// -----------------------------------------------------------------------------
	// emis initial
	var topicPathInitial = urlParams.get('topic')
	if (topicPathInitial) {
		if (topicQuickPath[topicPathInitial]) {
			unSelectedProjectboard()
			setTimeout(() => { topicQuickPath[topicPathInitial]() })
		} else $('#menu').modal({});
	} else $('#menu').modal({})
	// modal dialog關閉時偵測是否有選取emis專案
	$('#menu').on('hidden.bs.modal', function(event){
		if (!emis_event_select && !board_make_conditon) {
			var nowMenuNavId = $("#menu_bar .nav-link.active").attr("id")
			if (nowMenuNavId == "main-1") {
				$("#main-1").click()
			}
			unSelectedProjectboard()
		};
	})
	// modal dialog關閉時同時關閉強降雨應變機制
	$('#event_modal').on('hidden.bs.modal', function(){
		if (eoc_advice_updater.action) {
			eoc_advice_updater.action = false
			clearInterval(eoc_advice_updater.updater)
		}
	})
	// modal dialog關閉時同時關閉CCTV串流
	$('#modal-cctv').on('hidden.bs.modal', function(){
		$('#modal-cctv .modal-body').html("")
	})
	// 全頁 Tooltip 提示設定
	$('[hover_toggle="true"]').tooltip()
	// -----------------------------------------------------------------------------

	// 儀表板面控制項
	$("#right").click(function(){
		$(".panel").css("left","0%");
		$("#nav_bar").hide();
		$("#topright_div").css("top","10px");
		$("#topic_div").css("top","10px");
		resetLegendDivPosititon("open")
	}).click();
	$("#dashboard_toggle_mobile").click((e) => {
		if ($(window).width() < 450) {
			e.preventDefault()
			$("#board_close").click()
		}
	})
	// 關閉儀表板面
	$("#board_close").click(function(){
		$(".panel").css("left","-1000%");
		$("#panel_subtitle").appendTo($("#nav_info"));
		$("#nav_bar").show();
		$("#topright_div").css("top","50px");
		$("#topic_div").css("top","50px");
		resetLegendDivPosititon("close")
	});
	// 初始化儀表板面
    $("#board_fold").click(function(){
    	$('.panel').css("width", "32vw");
    	$("#menu_bar").css("display", "flex");
    	$('#board_list').css("font-size", "1.2rem");
    	$('#board_list .badge').css("font-size", "1rem");
    	$('.title').css("font-size", "1.25rem");
    	$('#board_title').css("display", "none");
    	// subtitle
    	var subtitle_string = $('#siderbar_subtitle').html();
		var new_subtitle_string = subtitle_string.split("&nbsp;&nbsp;&nbsp;&nbsp;");
		if (new_subtitle_string.length == 3) {
			$('#siderbar_subtitle').html(new_subtitle_string[0] + "<br>" + new_subtitle_string[1] + "&nbsp;&nbsp;&nbsp;&nbsp;" + new_subtitle_string[2]);
			$('#siderbar_subtitle').css("text-align", "unset");
		}
    	board_col_12();
		marquee_adjust_position();
		resetLegendDivPosititon("open")
    	setTimeout(function(){
	    	highchart_reflow();
		}, 1000);
    });
	// 放大儀表板面(一分割)
	$("#board_expand_one").click(function(){
    	$('.panel').css("width", "100%");
    	$("#menu_bar").css("display", "none");
    	$('#board_list').css("font-size", "1.5rem");
    	$('#board_list .badge').css("font-size", "1.25rem");
    	$('.title').css("font-size", "1.5rem");
    	$('#board_title').css("display", "block");
    	// subtitle
    	var subtitle_string = $('#siderbar_subtitle').html();
    	var new_subtitle_string = subtitle_string.split("<br>");
    	$('#siderbar_subtitle').html(new_subtitle_string[0] + "&nbsp;&nbsp;&nbsp;&nbsp;" + new_subtitle_string[1]);
    	$('#siderbar_subtitle').css("text-align", "center");
    	board_col_12();
    	marquee_adjust_position();
    	setTimeout(function(){
	    	highchart_reflow();
		}, 1000);
    });
	// 放大儀表板面(全螢幕)
	$("#board_expand_two").click(function(){
    	$('.panel').css("width", "100%");
    	$("#menu_bar").css("display", "none");
    	$('#board_list').css("font-size", "1.5rem");
    	$('#board_list .badge').css("font-size", "1.25rem");
    	$('.title').css("font-size", "1.5rem");
    	$('#board_title').css("display", "block");
    	// subtitle
    	var subtitle_string = $('#siderbar_subtitle').html();
    	var new_subtitle_string = subtitle_string.split("<br>");
    	$('#siderbar_subtitle').html(new_subtitle_string[0] + "&nbsp;&nbsp;&nbsp;&nbsp;" + new_subtitle_string[1]);
    	$('#siderbar_subtitle').css("text-align", "center");
    	var board_html = $('#board_list .row').detach();
    	board_html.find(".col-12").each(function(){
    		$(this).removeClass("col-12");
    		$(this).addClass("col-6");
    	})
    	$('#board_list').append('<div class="row"></div>');
    	$('#board_list').append(board_html);
    	marquee_adjust_position();
    	setTimeout(function(){
	    	highchart_reflow();
		}, 1000);
    });
	// 調整看板項目
    $("#board_content_control").click(function(){
    	// consider marquee on / off & it's current content
		var current_marquee_content = $("#board_marquee").html();
		var boolean = $('#board_marquee').parent().parent().css("display");
		var option;
		if (boolean == "block") {
			option = '<option value="1">開啟</option><option value="2">關閉</option>';
		} else {
			option = '<option value="2">關閉</option><option value="1">開啟</option>';
		}
    	var html_string =
    		'<h4>災情看板資訊設定</h4>'+
    		'<div class="input-group mb-2">'+
    			'<div class="input-group-prepend">'+
    				'<label class="input-group-text">跑馬燈顯示設定</label>'+
    			'</div>'+
    			'<select class="custom-select">'+
    				option +
    			'</select>'+
    		'</div>'+
    		'<div class="input-group mb-2">'+
    			'<div class="input-group-prepend">'+
    				'<span class="input-group-text">跑馬燈文字資訊</span>'+
    			'</div>'+
    			'<textarea class="form-control" aria-label="With textarea">'+ current_marquee_content +'</textarea>'+
    		'</div>';
   		// consider board item on / off
    	$('#board_list .move_element').each(function(index){
    		var title_val = $(this).find(".move_content_text_value").html() + "顯示設定";
    		var boolean = $(this).css("display");
    		var option;
    		if (boolean == "block") {
    			option = '<option value="1">開啟</option><option value="2">關閉</option>';
    		} else {
    			option = '<option value="2">關閉</option><option value="1">開啟</option>';
    		}
    		html_string +=
	    		'<div class="input-group mb-2">'+
	    			'<div class="input-group-prepend">'+
	    				'<label class="input-group-text">'+ title_val +'</label>'+
	    			'</div>'+
	    			'<select class="custom-select">'+
	    				option +
	    			'</select>'+
	    		'</div>';
    	});
    	// modal event
    	html_string += '<button id="board_setting_trig" type="button" class="btn btn-primary btn-lg btn-block">提交本次設定</button>';
    	modal_open(html_string);
    	// event handler
    	setTimeout(function(){
    		$("#board_setting_trig").click(function(){
    			// marquee_text setting
    			var marquee_text = $("#event_container textarea").val();
    			if (marquee_text != "") {
    				$("#board_marquee").html(marquee_text);
    			}
    			// display setting
	    		$("#event_container :selected").each(function(index){
	    			var boolean = $(this).val();
	    			if (index == 0) {
	    				// marquee display setting
		    			if (boolean == "1") {
		    				$('#board_marquee').parent().parent().css("display", "block");
		    			} else {
		    				$('#board_marquee').parent().parent().css("display", "none");
		    			}
	    			} else {
	    				// board item display setting
		    			if (boolean == "1") {
		    				$('#board_list .move_element').eq(index-1).css("display", "block");
		    			} else {
		    				$('#board_list .move_element').eq(index-1).css("display", "none");
		    			}
	    			}
	    		});
	    		$('#event_modal').modal('hide');
    		});
    	}, 2000)
    });
    // 看板自動捲動
    var board_move_updater = undefined;
	function board_move_control(){
		var sec = new Date().getSeconds();
		var boolean1 = (sec % 5 == 0);
		var boolean2 = (sec % 2 == 0);
		if (boolean1 && boolean2) {
			$("#home3").animate({ scrollTop: $("#home3").height() }, 1000);
		} else if(boolean1 && (boolean2==false)) {
			$("#home3").animate({ scrollTop: 0 }, 1000);
		} else {

		}
	}
	$("#board_auto_move").click(function(){
		var boolean = $(this).val();
		if (boolean == "0") {
			$(this).val("1");
			board_move_updater = setInterval(board_move_control, 1000);
		} else {
			$(this).val("0");
			clearInterval(board_move_updater);
		}
	});
	// 最佳化災情管理版面
	$("#report_best_ui").click(function(){
		var boolean = $(this).val();
		if (boolean == "0") {
			$(this).val("1");
			$('.panel').css("width", "50%");
			report_col_control("col-12", "col-6");
		} else {
			$(this).val("0");
			$('.panel').css("width", "25%");
			report_col_control("col-6", "col-12");
		}
		highchart_reflow();
	});
	// 彈性災情選取功能
	$("#flex_event").click(function(){
		if($("#event_multi_select_trig").length == 0){
			create_flex_event();
		} else {
			$('#event_flex_modal').modal({});
		}
	})
	// 儀表板頁籤選擇
	$("#main-1").click(function(){ marquee_adjust_position() })
	$("#main-2").click(() => {}) // ???????????????????
	$('#main-3').one("click", () => { prediction_normal_info() }); // 重回災情預測保留前次預測模組
	$('#main-3').click(() => { $("#map_clear").click() })
	$("#main-4").click(function(){ $("#topic-quick-dropdown").toggle() })
	// 預警監控主題選擇(點擊預警監控頁籤/下拉選單)
	$("#topic-quick-dropdown .dropdown-item").click(function(){
		var page = $(this).attr('page')
		$('#' + page).click()
	})
    // 預警監控主題選擇 & 登出功能(地圖右上角功能列)
    $("#t_initial").click(function(project_id_query){
    	loader_asynchronous(function(){
	    	// layer_table_redraw();
			$("#map_clear").click();
			if (emis_event_select) {
				if (raw_data["emisProjectEarthquakeGridLayer"]) {
					overlay_dataset["emisProjectEarthquakeGridLayer"] = raw_data["emisProjectEarthquakeGridLayer"]
					overlay_dataset["emisProjectEarthquakeGridLayer"].addTo(map)
					$("#legend_div_container").append('<div class="legend_text">震央位置<br><img src="marker_icon/earthquake_center.png" width="32"></div><div class="legend_text">震度網格<br><img src="Legend/earthquake_pga_grid.jpg" width="100%"></div>')
				}
				backgroud_layer_control("重大災情");
				backgroud_layer_control("一般災情");
				$("#base_layer .leaflet-layerstree-children").find("input").eq(4).click();
				$("#home_view").click();
				$("#main-2").click();
			}
	    });
    });
    $("#t_typhoon").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
	    	if (!disable_map_clear) $("#map_clear").click();
			backgroud_layer_control("颱風動向");
			backgroud_layer_control("潮位站");
			backgroud_layer_control("浮標站");
			backgroud_layer_control("異常波浪");
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(7).click();
	    	map.setView([25.038169, 121.557588], 6);
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	topic_weather();
			disable_map_clear = false
    	});
    });
    $("#t_rain").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
	    	if (!disable_map_clear) $("#map_clear").click();
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(5).click();
	    	map.setView([25.038169, 121.280], 10);
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	backgroud_layer_control("雨量站");
			backgroud_layer_control("雷達強回波值");
			rain_dynamic_viewer();
			emisEventPointOpenInTopic()
			disable_map_clear = false
    	});
    });
    $("#t_alarm").click(function(){
    	loader_asynchronous(function(){
	    	$("#home_view").click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_alarm();
			emisEventPointOpenInTopic()
			disable_map_clear = false
    	});
    });
	$("#t_alarm_debris").click(function(){
    	loader_asynchronous(function(){
	    	$("#home_view").click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_alarm('#t_hillslope','#collapse3');
			emisEventPointOpenInTopic()
			disable_map_clear = false
    	});
    });
    $("#t_cctv").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
			if (!disable_map_clear) $("#map_clear").click();
	    	backgroud_layer_control("警察局CCTV");
			backgroud_layer_control("新聞局公共監測CCTV");
			// backgroud_layer_control("水利局河川CCTV");
			backgroud_layer_control("水利局高灘地CCTV");
			backgroud_layer_control("水利署CCTV");
			backgroud_layer_control("水保署CCTV");
			backgroud_layer_control("交通局CCTV");
			backgroud_layer_control("高公局CCTV");
			backgroud_layer_control("公路局CCTV");
			backgroud_layer_control("道路管理中心CCTV");
			backgroud_layer_control("區公所水域CCTV");
			backgroud_layer_control("車行地下道CCTV");
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	$("#home_view").click();
			topic_cctv();
			emisEventPointOpenInTopic()
			disable_map_clear = false
    	});
    });
    $("#t_earthquake").click(function(){
    	loader_asynchronous(function(){
			layer_table_redraw();
			// backgroud_layer_control("近期有感地震");
	    	if (!disable_map_clear) $("#map_clear").click();
			$("#home_view").click();
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	map.setView([25.02650624267848, 121.38427731581034], 10)
			try {
				topic_earthquake();
			} catch (e) {
				console.log(e)
				toast_open("地震模組運作異常")
			}
			disable_map_clear = false
    	});
    });
	$("#t_earthquake_ncdr").click(function(){
    	loader_asynchronous(function(){
			layer_table_redraw();
			// backgroud_layer_control("近期有感地震");
	    	if (!disable_map_clear) $("#map_clear").click();
			$("#home_view").click();
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	map.setView([25.02650624267848, 121.38427731581034], 10)
			try {
				topic_earthquake('ncdr');
			} catch (e) {
				console.log(e)
				toast_open("地震模組運作異常")
			}
			disable_map_clear = false
    	});
    });
	$("#t_earthquake_1click").click(function(){
    	loader_asynchronous(function(){
			layer_table_redraw();
			// backgroud_layer_control("近期有感地震");
	    	if (!disable_map_clear) $("#map_clear").click();
			$("#home_view").click();
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
	    	map.setView([25.02650624267848, 121.38427731581034], 10)
			try {
				topic_earthquake('one-click');
			} catch (e) {
				console.log(e)
				toast_open("地震模組運作異常")
			}
			disable_map_clear = false
    	});
    });
    $("#t_hillslope_community").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
	    	if (!disable_map_clear) $("#map_clear").click();
	    	backgroud_layer_control("山坡地風險社區");
			backgroud_layer_control("坪林分隊水保觀測");
			backgroud_layer_control("人工邊坡示警");
	    	$("#home_view").click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_hillslope_community();
			disable_map_clear = false
    	});
    });
	$("#t_fire_report").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
			$("#map_clear").click();
			backgroud_layer_control("狹小巷道火災搶救不易地區");
			// backgroud_layer_control("水源缺乏地區");
			dangerous_buildings_filter = {}
			backgroud_layer_control("高危險建築物-點位圖");
			backgroud_layer_control("毒化物與其他化學品-點位圖");
	    	$("#home_view").click();
			$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_fire_report();
    	});
    });
	// $("#t_pinplin").click(function(){
    // 	loader_asynchronous(function(){
	// 		$("#other-system-container").html(
	// 			'<form class="d-none" target="_blank" id="form1" action="https://iot.thinktron.co/platform/ntu-ffews/app.php" method="post">' +
	// 				'<input id="login-username" value="ntu" type="text" name="loginUsername" required data-msg="Please enter your username" class="input-material">' +
	// 				'<input id="login-password" value="1999" type="password" name="loginPassword" required data-msg="Please enter your password" class="input-material">' +
	// 			'</form>'
	// 		)
	// 		setTimeout(function(){
	// 			toast_open("將前往至「坪林𩻸魚堀溪汛洪預警系統」！")
	// 			$('#form1').submit()
	// 		}, 1000)
    // 	})
	// })
	$("#t_volcano").click(function(){
    	loader_asynchronous(function(){
	    	layer_table_redraw();
	    	$("#map_clear").click();
	    	$("#home_view").click();
			$("#main-4").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_volcano();
    	});
    });
	$("#t_covid19").click(function(){
		var covidDeafultKey = $(this).attr('covid-project-default-key'),
			covidDeafultStart = $(this).attr('covid-project-default-start'),
			covidDeafultEnd = $(this).attr('covid-project-default-end')
    	loader_asynchronous(function(){
	    	layer_table_redraw();
	    	$("#map_clear").click();
	    	$("#base_layer .leaflet-layerstree-children").find("input").eq(4).click();
	    	$("#main-4").click();
			$("#home_view").click();
			$("#topic-quick-dropdown").css("display", "none")
			topic_covid19(covidDeafultKey, covidDeafultStart, covidDeafultEnd);
    	});
    });
	$("#t_live_broadcast").click(function(){
		topic_live_broadcast_test();
		$('#live_broadcast').removeClass('d-none');
	})
	// 登出功能
	$("#t_logout").click(function(){
		$.ajax({
			url: publicPath + '/napi/logout',
			method: 'GET',
			async: false,
			headers: {
				Authorization: 'Bearer ' + jwt_token
			},
			error: function(e){
				if(e.statusText == "UNAUTHORIZED"){
					jwtLogout()
				}
			}
		}).done(function() {
			jwtLogout()
		})
	})

    $("#home4").on("click", ".slider-card-head", function(){
    	var boolean = $(this).siblings().hasClass("d-none");
    	if (boolean) {
    		$(this).siblings().removeClass("d-none");
    		$(this).children("h5").children("i").attr("class", 'fas fa-angle-down float-right mt-1');
    	} else {
    		$(this).siblings().addClass("d-none");
    		$(this).children("h5").children("i").attr("class", 'fas fa-angle-up float-right mt-1');
    	}
    })
	// 地圖右上角功能列
	// 地圖放大
	$("#map_in").click(function(){ map.zoomIn(); })
	// 地圖縮小
	$("#map_out").click(function(){ map.zoomOut(); })
	// 地址定位
	$("#address_search_trig").click(function(){
		var status = $("#address_input_div").css("display");
		if (status == "none") {
			$("#address_input_div").css("display", "block");
		} else {
			$("#address_input_div").css("display", "none");
		}
	});
	// 示警基準小幫手
	$("#alerting_info").click(function(){
		var alerting_info_string =
			'<h3 class="font-weight-bold text-center">警戒示警標準及定義</h3>'+
			'<h4 class="font-weight-bold">壹、淹水警戒</h4>'+
			'<h5>一、定義</h5>'+
			'<p>(一)二級警戒：發布淹水警戒之鄉(鎮、市、區)如持續降雨，其轄內易淹水村里及道路可能三小時內開始積淹水。(地圖以黃色表示二級)</p>'+
			'<p>(二)一級警戒：發布淹水警戒之鄉(鎮、市、區)如持續降雨，其轄內易淹水村里及道路可能已經開始積淹水。(地圖以紅色表示一級)</p>'+
			'<p>註：淹水警戒準確性受降雨時空分布不均、雨量站密度、地形地物、河川排水及其當時水位高低、沿海潮位、排水流路阻塞等因素影響 可配合即時雨量觀測（如QPESUMS）及當地降雨實況研判因應。</p>'+
			'<h5>二、資料來源：<a href="http://fhy2.wra.gov.tw/fhy/" target="_blank">經濟部水利署防災資訊服務網</a></h5></h5>'+
			'<h4 class="mt-3 font-weight-bold">貳、水位警戒</h4>'+
			'<h5>一、定義</h5>'+
			'<p>(一)三級警戒水位：河川水位預計未來2小時到達高灘地之水位。(地圖以黃色表示三級)</p>'+
			'<p>(二)二級警戒水位：河川水位預計未來5小時到達計畫洪水位(或堤頂)時之水位。(地圖以橘色表示二級)</p>'+
			'<p>(三)一級警戒水位：河川水位預計未來2小時到達計畫洪水位(或堤頂)時之水位。(地圖以紅色表示一級)</p>'+
			'<p>註：各河川依不同防救災需求到達計畫洪水位(或堤頂)的時間有所不同。</p>'+
			'<h5>二、資料來源：<a href="http://fhy2.wra.gov.tw/fhy/" target="_blank">經濟部水利署防災資訊服務網</a></h5>'+
			'<h4 class="mt-3 font-weight-bold">參、水庫放水定義</h4>'+
			'<h5>一、定義</h5>'+
			'<p>(一)放流狀態：預計放水。(地圖以橘色表示)</p>'+
			'<p>(二)放流狀態：放水。(地圖以紅色表示)一級警戒水位：河川水位預計未來2小時到達計畫洪水位(或堤頂)時之水位。(地圖以紅色表示一級)</p>'+
			'<h5>二、<a href="http://fhy2.wra.gov.tw/fhy/" target="_blank">資料來源：經濟部水利署防災資訊服務網</a></h5>'+
			'<h4 class="mt-3 font-weight-bold">肆、土石流警戒</h4>'+
			'<h5>一、定義</h5>'+
			'<p>(一)黃色警戒：土石流「黃色警戒」的意義為當某地區的「預測雨量」大於當地的「土石流警戒基準值」。</p>'+
			'<p>(二)紅色警戒：當某地區的「實際降雨」大於當地的「土石流警戒基準值」。</p>'+
			'<h5>二、資料來源：<a href="https://246.swcb.gov.tw/debrisClassInfo/qanda/qanda.aspx" target="_blank">行政院農業委員會水土保持局土石流防災資訊網</a></h5>'+
			'<h4 class="mt-3 font-weight-bold">伍、雨量分級定義</h4>'+
			'<h5>一、定義</h5>'+
			'<p>(一)大雨：指24小時累積雨量達80毫米以上，或時雨量達40毫米以上之降雨現象。</p>'+
			'<p>(二)豪雨：指24小時累積雨量達200毫米以上，或3小時累積雨量達100毫米以上之降雨現象。</p>'+
			'<p>(三)大豪雨：24小時累積雨量達350毫米以上稱之為。</p>'+
			'<p>(四)超大豪雨：24小時累積雨量達500毫米以上稱之為。</p>'+
			'<h5>二、資料來源：<a href="https://www.cwa.gov.tw/V7/observe/rainfall/define.htm" target="_blank">交通部中央氣象局</a></h5>'+
			'<h6 class="text-right">彙整與提供：整備應變科</h5>';
		modal_open(alerting_info_string);
	})

	// 地圖右下角功能列
	// 現在時間
	setInterval(showTime, 1000);
	var today = new Date();
	$('#nowdate').html(`${today.getFullYear()}/${(today.getMonth()+1)}/${today.getDate()}`)
	// google map
	var geocoder = new google.maps.Geocoder;
	$("#go_address_location").click(function(){
		var address = $("#address_location_input").val();
		geocoder.geocode({'address': address}, function(results, status) {
			if (status === 'OK') {
				var first_key = Object.keys(results[0].geometry.viewport);
				var second_key_y = Object.keys(results[0].geometry.viewport[first_key[0]]);
				var second_key_x = Object.keys(results[0].geometry.viewport[first_key[1]]);
				var x_coor = (results[0].geometry.viewport[first_key[1]][second_key_x[0]] + results[0].geometry.viewport[first_key[1]][second_key_x[1]]) / 2;
				var y_coor = (results[0].geometry.viewport[first_key[0]][second_key_y[0]] + results[0].geometry.viewport[first_key[0]][second_key_y[1]]) / 2;
				if ((x_coor > 121.248 && x_coor < 122.018) && (y_coor > 24.666 && y_coor < 25.38)) {
					map.setView([y_coor, x_coor], 16);
					var position_marker = L.marker([y_coor, x_coor]);
					var position_label = L.marker([y_coor, x_coor], {
						icon: createLabelIcon("leaflet-textLabelclass", address)
					});
					if (overlay_dataset["lbs_map"] != undefined){map.removeLayer(overlay_dataset["lbs_map"])}
					overlay_dataset["lbs_map"] = L.layerGroup([position_marker, position_label]).addTo(map)
				} else {
					alert("Google定位無法判斷此地標或地址");
				}
			} else {
				alert("查詢定位系統介接發生問題，請稍後再試！");
			}
		})
	})
	$("#delete_address_location").click(function(){
		if (overlay_dataset["lbs_map"] != undefined) {
			map.removeLayer(overlay_dataset["lbs_map"]);
		}
	})
	// 專案選擇
	$("#renew_projqct").click(function(){
		$('#menu').modal({});
	})
	$('#project_submit').click(() => { submit_project() }) // 確認專案選擇
	// 圖層開關
	$("#dropdown_layer").click(function(){
		$("#layer_control").toggle();
  	})
    // 圖層清除
    $("#map_clear").click(function(){
    	layer_remove()
		$("#legend_div_container").html('')
		// resetting
		map.off("click")
		wmsQueryTargetList = []
    });
	// 強降雨應變機制
	$("#eoc-advice-trig").click(function(){
		doEocAdviceModalContent()
		eoc_advice_updater.updater = setInterval(doEocAdviceModalContent, (60000 * 0.5))
		function doEocAdviceModalContent(){
			eoc_advice_updater.action = true
			var res = ajax_call(publicPath + "/napi/obs/eocadvice"),
				data = res[0],
				categoryRankArray = {
					"雨情巡查": {
						key: "雨情巡查",
						html: '<i class="fas fa-square-full mr-2 eoc-advice-c1"></i>',
						color: " #2276bf"
					}, "區公所強化三級": {
						key: "區公所強化三級",
						html: '<i class="fas fa-square-full mr-2 eoc-advice-c2"></i>',
						color: "#cd2701"
					}, "水災強化三級": {
						key: "水災強化三級",
						html: '<i class="fas fa-square-full mr-2 eoc-advice-c3"></i>',
						color: "#63c521"
					// }, "eoc": {
					// 	key: "eoc",
					// 	html: '<i class="fas fa-square-full mr-2 eoc-advice-c4"></i>',
					// 	color: "#6000a2"
					}
				},
				thisHtml,
				adviceTableHtml = {
					parent: '<table class="table table-bordered table-sm text-center" id="eoc-advice-table"><thead class="thead-dark"><tr><th>行政區</th><th>建議啟動程度</th><th>行政區</th><th>建議啟動程度</th></tr></thead><tbody></tbody><thead class="thead-dark"><tr><th>行政區</th><th>建議啟動程度</th><th>行政區</th><th>建議啟動程度</th></tr></thead></table>',
					tbody: ''
				},
				adviceTableObject = {}

			overlay_dataset["Basic_map"].features.forEach(function(feature){
				var thisTown = feature.properties["TOWNNAME"],
					statusList = Object.keys(categoryRankArray)
				adviceTableObject[thisTown] = {
					status: [],
					html: "",
					statusCode: 0
				}
				statusList.forEach(function(each, keyIndex){
					var indexResult = data.content[each].includes(thisTown)
					if (indexResult) {
						adviceTableObject[thisTown].status.push(each)
						adviceTableObject[thisTown].html = ""
						adviceTableObject[thisTown].statusCode = keyIndex + 1
						var thisStatusIndex = keyIndex
						for (var index = 0; index <= thisStatusIndex; index++) {
							adviceTableObject[thisTown].html += categoryRankArray[statusList[index]].html
						}
					}
				})
			})
			var regionArray = Object.keys(adviceTableObject).sort(function(a, b){
				return adviceTableObject[b].statusCode - adviceTableObject[a].statusCode
			})
			regionArray.forEach(function(each, index){
				if ((index % 2) == 0) {
					if ((index + 1) == regionArray.length) {
						adviceTableHtml.tbody += `
							<tr>
								<td>${each}</td>
								<td class="text-left">${adviceTableObject[each].html}</td>
								<td></td>
								<td></td>
							</tr>`
					} else {
						adviceTableHtml.tbody += `
							<tr>
								<td>${each}</td>
								<td class="text-left">${adviceTableObject[each].html}</td>
								<td>${regionArray[index + 1]}</td>
								<td class="text-left">${adviceTableObject[regionArray[index + 1]].html}</td>
							</tr>`
					}
				}
			})
			thisHtml = `
				<div class="row">
					<div class="mt-3 p-no-ev col-5">
						<div class="h5"><i class="fas fa-square-full mr-2 eoc-advice-c1"></i>當日值勤人員進駐EOC</div>
						<div class="h5"><i class="fas fa-square-full mr-2 eoc-advice-c2"></i>雨情巡查/區公所強化三級</div>
						<div class="h5"><i class="fas fa-square-full mr-2 eoc-advice-c3"></i>強降雨強化三級</div>
						<div class="h-400 w-100 bg-white" id="eoc-advice-map"></div>
					</div>
					<div class="mt-3 col-7">${adviceTableHtml.parent}</div>
				</div>
				<h6>*此頁面每30秒刷新，上方地圖及表格內空白表示無建議</h6>`
				// <div class="col-3 h5"><i class="fas fa-square-full mr-2 eoc-advice-c4"></i>進駐EOC</div>
			// 更新時間格式處理
			let t = data.notify_time.split(' ')
			let notify_time = `${t[3]}/${month_str2_value(t[2])}/${t[1]} ${t[4]}`
			modal_open(thisHtml, '強降雨應變機制啟動與撤除建議 (更新時間：' + notify_time + ')<a class="float-right" href="images/強降雨應變機制啟動及撤除標準表.pdf" target="_blank"><i class="fas fa-question-circle mr-2"></i>啟動標準說明</a>')
			setTimeout(function(){
				var eocAdviceMap = new L.Map('eoc-advice-map', {
						preferCanvas: true,
						attributionControl: false,
						zoomControl: false,
						center: new L.LatLng(25.008169, 121.557588),
						zoom: 10,
						zoomSnap: 0.25
					}),
					ntcLayer = L.geoJson(overlay_dataset["Basic_map"], {
						style: function(feature){
							var thisStatus = adviceTableObject[feature.properties["TOWNNAME"]].status, color
							if (thisStatus.length == 0) {
								color = 'white'
							} else {
								color = categoryRankArray[thisStatus[thisStatus.length - 1]].color
							}
							return { color: 'black', weight: 2, opacity: 1, fillOpacity: 1, fillColor: color }
						}
					}).addTo(eocAdviceMap)
				eocAdviceMap.fitBounds(ntcLayer.getBounds())
				$("#eoc-advice-table tbody").html(adviceTableHtml.tbody)
			}, 1500)
		}
	})
	// 切換視角到新北市中心
	$("#home_view").click(function () {
		if (overlay_dataset["temp_map"] != undefined) {
			map.removeLayer(overlay_dataset["temp_map"]);
		}
		map.setView([25.038169, 121.557588], 11);
		setTimeout(function(){
			map.panBy([-80, 0]);
		}, 500)
	});
	// 全螢幕檢視
	$('#fullScreen').click(function() {
		if ($(this).val() == "false") {
			screenfull.request();
			$(this).val("true");
		} else {
			screenfull.exit();
			$(this).val("false");
		}
	});
	// CCTV群組
	$("#cctv_group").dialog({
		title: 'CCTV群組',
		autoOpen: false,
		width: 1010,
		height: 'auto',
		resizable: false,
		position: { my: "center", at: "center", of: window },
	});
	$("#cctv_group")
		.prev(".ui-dialog-titlebar")
		.append(
			`<div style="position:absolute; right: 3px; top: 3px">
				<span>CCTV數量：</span>
				<button class="cctv_capacity mr-1 bg-warning" value="2">2</button>
				<button class="cctv_capacity mr-1" value="3">3</button>
				<button class="cctv_capacity mr-1" value="4">4</button>
				<button class="cctv_capacity mr-1" value="6">6</button>
				<button id="cctv_clean_all" class="btn btn-sm btn-danger mr-2">清空CCTV</button>
				<button id="close_cctv_group" class="btn btn-sm btn-secondary">關閉</button>
			</div>`
		)

	let cctv_capacity = 2
	let container_size = cctv_capacity % 3 == 0 ? '3x' : '2x'
	let cctv_dynamic_html = ''
	for (let i = 0; i < 6; i++) {
		cctv_dynamic_html += `
		<div id="cctv-order-${i+1}" class=${(i+1) > cctv_capacity ? 'd-none':''}>
			<div class="d-flex justify-content-between align-items-center px-2">
				<h6 class="text-truncate" style="max-width:270px">CCTV ${i+1}</h6>
				<button type="button" class="btn btn-secondary btn-sm remove_cctv
					${(i+1) > cctv_render_list ? 'd-none':''}">
					<i class="fas fa-trash-alt"></i>
				</button>
			</div>
			<div class="card bg-light mx-1 cctv-container-size-${container_size}">
				<div class="card-body" id="cctv-container-${i+1}" style="overflow: hidden">
					<h4 class="card-title">CCTV ${i+1}</h4>
				</div>
			</div>
		</div>`
	}

	// $('#cctv_container').html(cctv_dynamic_html)
	$('#cctv_container').html(`
	<div class="d-flex flex-wrap" id="cctv_frame">
		${cctv_dynamic_html}
	</div>`)

	cctv_render_list.forEach((el, index) => {
		cctv_group_append(el.station_name, el.url_string, el.url_type, index+1)
	})
	for (let i = 0; i < 6; i++) {
		(i+1) > cctv_render_list.length
			? $("#cctv-order-" + (i+1) + ' button').addClass('d-none')
			: $("#cctv-order-" + (i+1) + ' button').removeClass('d-none')
	}
	$('.cctv_capacity').on('click', function(e){
		let cctv_capacity = Number(e.target.value)
		$('.cctv_capacity').removeClass('bg-warning')
		$(this).addClass('bg-warning')
		cctv_capacity % 3 == 0
			? $('.cctv-container-size-2x').removeClass('cctv-container-size-2x').addClass('cctv-container-size-3x')
			: $('.cctv-container-size-3x').removeClass('cctv-container-size-3x').addClass('cctv-container-size-2x')
		for (let i = 0; i < 6; i++) {
			(i+1) > cctv_capacity
				? $("#cctv-order-" + (i+1)).addClass('d-none')
				: $("#cctv-order-" + (i+1)).removeClass('d-none')
		}
	})
	$('.reset_cctv').on('click', function(e){
		let target = $(e.target).siblings('h6').text()
		let target_index =  cctv_render_list.findIndex(el => el.station_name == target)
		cctv_render_list[target_index].url_string = cctv_render_list[target_index].url_type == 'rtsp' ? cctv_render_list[target_index].url_string : cctv_render_list[target_index].url_string + '&t=' + new Date().getTime()
	})
	$('.remove_cctv').on('click', function(e){
		let target = $(e.target).siblings('h6').text()
		let target_index =  cctv_render_list.findIndex(el => el.station_name == target)
		cctv_render_list.splice(target_index, 1)
		// remove all
		for (let i = 0; i < 6; i++) {
			$("#cctv-order-" + (i+1) + ' h6').text(`CCTV ${i+1}`)
			$("#cctv-order-" + (i+1) + ' button').addClass('d-none')
			$("#cctv-container-" + (i+1)).html(`<h4>CCTV ${i+1}</h4>`)
		}
		// add the remained cctv
		cctv_render_list.forEach((el, index) => {
			cctv_group_append(el.station_name, el.url_string, el.url_type, index+1)
			$("#cctv-order-" + (index+1) + ' button').removeClass('d-none')
		})
		topic_cctv()
		localStorage.setItem('cctv_render_list', JSON.stringify(cctv_render_list))
	})
	$('#cctv_clean_all').on('click', function(){
		if (cctv_render_list.length == 0) return
		let confirm_clean = confirm('確定要清除所有CCTV畫面？')
		if (confirm_clean) {
			cctv_render_list = []
			for (let i = 0; i < 6; i++) {
				$("#cctv-order-" + (i+1) + ' h6').text(`CCTV ${i+1}`)
				$("#cctv-order-" + (i+1) + ' button').addClass('d-none')
				$("#cctv-container-" + (i+1)).html(`<h4>CCTV ${i+1}</h4>`)
			}
			localStorage.setItem('cctv_render_list', JSON.stringify(cctv_render_list))
			topic_cctv()
		}
	})
	$('#open_cctv_group').on('click', function(){
		$('#cctv_group').dialog('open')
	})
	$('#close_cctv_group').on('click', function(){
		$('#cctv_group').dialog('close')
	})
	// 滑鼠座標
	var mouse_position, mouse_html_string
	map.addEventListener('mousemove', function(event) {
		mouse_position = [event.latlng.lng, event.latlng.lat];
		mouse_html_string = '<i class="fas fa-mouse-pointer"></i>WGS84：' + mouse_position[0].toFixed(3) + ", " + mouse_position[1].toFixed(3);
		$("#mouse_position").html(mouse_html_string);
	})


	$("#select_project_type, #select_scenario_type").change(function(){
		var trigId = $(this).attr("id"),
			what_type = $("#" + trigId + " option:selected")[0].attributes[0].value
		$('#project_name_list').empty()
		$('#project_description').empty()

		$("#" + trigId + " option").eq(0).attr("disabled", true)
		if (trigId == "select_project_type") {
			// $("#select_scenario_type option").eq(0).attr("disabled", false)
			if ($("#select_project_type").val() == 'ALL') {
				$("#select_scenario_type").val("")
			} else {
				$("#select_scenario_type").val($("#select_project_type").val() + '情境')
			}
		} else if (trigId == "select_scenario_type") {
			// $("#select_project_type option").eq(0).attr("disabled", false)
			$("#select_project_type").val("未選擇")
		}
		if (what_type == "未選擇" || what_type.includes('情境')) {
			$('#project_name_filter').addClass('d-none')
			$('#project_submit').attr('disabled', false)
		} else {
			$('#project_name_filter').removeClass('d-none')
			get_project(what_type)
		}

    })
	$('#project_list_container').on('click', 'a', function(){
		var target = $(this).attr('href')
		$('#project_description div.active').removeClass('active')
		$(target).addClass('active')
	})


	// base layer
	var base_layer_list = $('.leaflet-control-layers-list').detach();
	$('#base_layer').append(base_layer_list);
	// over layer
	$('#over_layer').append(
		'<table class="table table-sm w-100" id="ovarlay_list">' +
	        '<thead>' +
		        '<tr>' +
		        	'<th class="d-none">層</th>' +
		        	'<th>類別</th>' +
		        	'<th class="text-center" style="width: 32px;">選</th>' +
		            '<th>名稱</th>' +
		        '</tr>' +
	        '</thead>' +
	        '<tbody>' +
	        '</tbody>' +
		'</table>'
	);
	// 套疊圖層清單
	var overlay_list = [
		{"name":"重大災情", "data":"重大災情", "category":"災情", "type":"案件", "legend": [{"name": "重大結案", "src": "marker_icon/event_serious_slove_new2.png"}, {"name": "重大未結", "src": "marker_icon/event_serious_new2.png"}]},
		{"name":"一般災情", "data":"一般災情", "category":"災情", "type":"案件", "legend": [{"name": "一般結案", "src": "marker_icon/event_normal_solve.png"}, {"name": "一般未結", "src": "marker_icon/event_normal_unsolve.png"}]},
		{"name":"避難收容場所", "data":"避難收容場所", "category":"災情", "type":"收容避難", "legend": [{"name": "避難收容場所", "src": "marker_icon/refuge_g.png"}, {"name": "避難收容場所開設", "src": "marker_icon/refuge_r.png"}], method:function(){ var result = refuge_swd(); return result;}},
		{"name":"救災物資配送站", "data":"救災物資配送站", "category":"災情", "type":"收容避難", "legend": [{"name": "救災物資配送站", "src": "marker_icon/square_blue.png"}], method:function(){ var result = supply_station(); return result;}},
		{"name":"颱風動向", "data":"颱風動向", "category":"情資", "type":"氣象颱風", "legend": [{"name": "颱風當前位置", "src": "marker_icon/typhoon.png"}, {"name": "颱風預估位置", "src": "marker_icon/typhoon-fcst.png"}, {"name": "颱風路線", "src": "marker_icon/typhoon_path.png"}, {"name": "七級暴風圈", "src": "Legend/typhoon_now_circle.png"}, {"name": "高侵襲範圍", "src": "Legend/typhoon_path_prob.png"}, {"name": "侵襲範圍機率", "src": "Legend/typhoon_prob.png", "width": "100%"}], method:function(){ var result = typhoon_info(); return result;}},
		{"name":"雨量站", "data":"雨量站", "category":"情資", "type":"氣象颱風", "legend": [{"name": "降雨正常", "src": "marker_icon/rain_g.png"}, {"name": "降雨大雨", "src": "marker_icon/rain_y.png"}, {"name": "降雨豪雨", "src": "marker_icon/rain_r.png"}, {"name": "降雨異常", "src": "marker_icon/rain_grey.png"}], method:function(){ var result = rain_cwb(); return result;}},
		{"name":"潮位站", "data":"潮位站", "category":"情資", "type":"氣象颱風", "legend": [{"name": "潮位站", "src": "marker_icon/tide.png"}], method:function(){ var result = tide_cwb(); return result;}},
		{"name":"浮標站", "data":"浮標站", "category":"情資", "type":"氣象颱風", "legend": [{"name": "浮標站", "src": "marker_icon/buoy.png"}], method:function(){ var result = buoy_cwb(); return result;}},
		{"name":"異常波浪", "data":"異常波浪", "category":"情資", "type":"氣象颱風", "legend": [], method:function(){ var result = abnormal_waves_cwb(); return result;}},
		{"name":"氣象站", "data":"氣象站", "category":"情資", "type":"氣象颱風", "legend": [{"name": "氣象站", "src": "marker_icon/wind.png"}], method:function(){ var result = wind_cwb(); return result;}},
		{"name":"日累積降雨", "data":"日累積降雨", "category":"情資", "type":"氣象颱風", "legend": [{"name": "日累積雨量", "src": "Legend/rain_day.png", "width": "100%"}], method:function(){ var result = overlayMaps['日累積降雨']; return result;}},
		{"name":"閃電觀測", "data":"閃電觀測", "category":"情資", "type":"氣象颱風", "legend": [{"name": "對地閃電", "src": "marker_icon/flash_ground.png"}, {"name": "雲間閃電", "src": "marker_icon/flash_cloud.png"}], method:function(){ var result = flash_cwb(); return result;}},
		{"name":"雷達強回波值", "data":"雷達強回波值", "category":"情資", "type":"氣象颱風", "legend": [{"name": "雷達強回波值", "src": "legend/radar_dbz_legend.jpg"}], method:function(){ var result = radar_cwb(); return result;}},
		{"name":"衛星雲圖", "data":"衛星雲圖", "category":"情資", "type":"氣象颱風", method:function(){ var result = overlayMaps['衛星雲圖']; return result;}},
		{"name":"集水區雨量-IoW", "data":"集水區雨量-IoW", "category":"情資", "type":"氣象颱風", "legend": [{"name": "時雨量", "src": "Legend/rain_day.png", "width": "100%"}], method:function(){ var result = get_iow_basin_rain(); return result;}},
		{"name":"即時淹水圖層-IoW", "data":"即時淹水圖層-IoW", "category":"情資", "type":"氣象颱風", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = get_iow_basin_depth_area(); return result;}},
		{"name":"原住民部落", "data":"原住民部落", "category":"情資", "type":"一般設施", "legend": [], method:function(){ var result = layer_ntc_aboriginal(); return result;}},
		{"name":"觀光景點", "data":"觀光景點", "category":"情資", "type":"一般設施", "legend": [{"name": "觀光景點", "src": "marker_icon/attractions.png"}], method:function(){ var result = layer_ntc_attraction(); return result;}},
		{"name":"林道", "data":"林道", "category":"情資", "type":"一般設施", "legend": [{"name": "林道", "src": "marker_icon/forest_road.png"}], method:function(){ var result = layer_ntc_forest_road(); return result;}},
		{"name":"步道", "data":"步道", "category":"情資", "type":"一般設施", "legend": [{"name": "步道", "src": "marker_icon/forest_road.png"}], method:function(){ var result = layer_ntc_hiking_road(); return result;}},
		{"name":"工業區範圍", "data":"工業區範圍", "category":"情資", "type":"一般設施", "legend": [], method:function(){ var result = layer_ntc_industry_region(); return result;}},
		{"name":"水利署水位", "data":"水利署水位", "category":"情資", "type":"警戒示警", "legend": [{"name": "水位正常", "src": "marker_icon/stage_0.png"}, {"name": "水位三級", "src": "marker_icon/stage_1.png"}, {"name": "水位二級", "src": "marker_icon/stage_2.png"}, {"name": "水位一級", "src": "marker_icon/stage_3.png"}, {"name": "水位離線", "src": "marker_icon/stage_999.png"}], method:function(){ var result = stage_wra(); return result;}},
		{"name":"水利局水位", "data":"水利局水位", "category":"情資", "type":"警戒示警", "legend": [{"name": "水位正常", "src": "marker_icon/stage_0.png"}, {"name": "水位三級", "src": "marker_icon/stage_1.png"}, {"name": "水位二級", "src": "marker_icon/stage_2.png"}, {"name": "水位一級", "src": "marker_icon/stage_3.png"}, {"name": "水位離線", "src": "marker_icon/stage_999.png"}], method:function(){ var result = stage_wrs(); return result;}},
		{"name":"淹水感知器", "data":"淹水感知器", "category":"情資", "type":"警戒示警", "legend": [{"name": "淹水感知器", "src": "marker_icon/flooding_sensor.png"}, {"name": "淹水感知器積水", "src": "marker_icon/flooding_sensor_30.png"}, {"name": "淹水感知器淹水", "src": "marker_icon/flooding_sensor_50.png"}, {"name": "淹水感知器異常", "src": "marker_icon/flooding_sensor_null.png"}], method:function(){ var result = layer_flood_sensor(); return result;}},
		{"name":"淹水感知器(車行地下道)", "data":"淹水感知器(車行地下道)", "category":"情資", "type":"警戒示警", "legend": [{"name": "車行地下道淹水感知器", "src": "marker_icon/flooding_sensor.png"}, {"name": "車行地下道淹水感知器積水", "src": "marker_icon/flooding_sensor_30.png"}, {"name": "車行地下道淹水感知器淹水", "src": "marker_icon/flooding_sensor_50.png"}, {"name": "車行地下道淹水感知器異常", "src": "marker_icon/flooding_sensor_null.png"}], method:function(){ var result = layer_underpass_water(); return result;}},
		{"name":"雨水下水道", "data":"雨水下水道", "category":"情資", "type":"警戒示警", "legend": [{"name": "雨水下水道", "src": "marker_icon/sewer_sensor.png"}], method:function(){ var result = layer_sewer_sensor(); return result;}},
		{"name":"土石流潛勢溪流", "data":"土石流潛勢溪流", "category":"情資", "type":"警戒示警", "legend": [{"name": "土石流正常", "src": "marker_icon/debris_g.png"}, {"name": "土石流黃色", "src": "marker_icon/debris_y.png"}, {"name": "土石流紅色", "src": "marker_icon/debris_r.png"}], method:function(){ var result = debris_flow_swcb(); return result;}},
		{"name":"土石流衝擊範圍", "data":"土石流衝擊範圍", "category":"情資", "type":"警戒示警", "legend": [{"name": "土石流衝擊範圍", "src": "marker_icon/debris_area.png"}], method:function(){ var result = debris_area_swcb(); return result;}},
		{"name":"崩塌潛勢範圍", "data":"崩塌潛勢範圍", "category":"情資", "type":"警戒示警", "legend": [{"name": "崩塌潛勢範圍", "src": "marker_icon/collapse_area.png"}], method:function(){ var result = collapse_area_swcb(); return result;}},
		{"name":"人工邊坡示警", "data":"人工邊坡示警", "category":"情資", "type":"警戒示警", "legend": [{"name": "人工邊坡山崩低發生度", "src": "marker_icon/landslide_low_green.png"}, {"name": "人工邊坡山崩中發生度", "src": "marker_icon/landslide_medium_yellow.png"}, {"name": "人工邊坡山崩中高發生度", "src": "marker_icon/landslide_medium_high_orange.png"}, {"name": "人工邊坡山崩高發生度", "src": "marker_icon/landslide_high_red.png"}], method:function(){ var result = layer_artificial_side_slope_risk(); return result;}},
		{"name":"新聞局公共監測CCTV", "data":"新聞局公共監測CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "新聞局", "src": "marker_icon/cctv_TV.png"}], method:function(){ var result = cctv_tv('news'); return result;}},
		{"name":"區公所水域CCTV", "data":"區公所水域CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "區公所", "src": "marker_icon/cctv_TV.png"}], method:function(){ var result = cctv_tv('district_office'); return result;}},
		// {"name":"水利局河川CCTV", "data":"水利局河川CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "水利局", "src": "marker_icon/cctv_wrs.png"}], method:function(){ var result = cctv_wrs(); return result;}},
		{"name":"水利局高灘地CCTV", "data":"水利局高灘地CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "高灘地", "src": "marker_icon/cctv_wrs.png"}], method:function(){ var result = cctv_wrs_hrcm(); return result;}},
		{"name":"水利署CCTV", "data":"水利署CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "水利署", "src": "marker_icon/cctv_wrap.png"}], method:function(){ var result = cctv_wra(); return result;}},
		{"name":"水保署CCTV", "data":"水保署CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "水保署", "src": "marker_icon/cctv_swcb.png"}], method:function(){ var result = cctv_swcb(); return result;}},
		{"name":"交通局CCTV", "data":"交通局CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "交通局", "src": "marker_icon/cctv_traffic.png"}], method:function(){ var result = cctv_traffic(); return result;}},
		{"name":"公路局CCTV", "data":"公路局CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "公路局", "src": "marker_icon/thb_cctv.png"}], method:function(){ var result = cctv_thb(); return result;}},
		{"name":"高公局CCTV", "data":"高公局CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "高公局", "src": "marker_icon/cctv_freeway.png"}], method:function(){ var result = cctv_freeway(); return result;}},
		{"name":"道路管理中心CCTV", "data":"道路管理中心CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "道路管理中心", "src": "marker_icon/cctv_iroad.png"}], method:function(){ var result = cctv_iroad(); return result;}},
		{"name":"車行地下道CCTV", "data":"車行地下道CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "車行地下道", "src": "marker_icon/cctv_wrs.png"}], method:function(){ var result = cctv_underpass(); return result;}},
		// {"name":"狹小巷道火災搶救不易地區", "data":"狹小巷道火災搶救不易地區", "category":"火災決策", "type":"火災決策", "mapType": "WMS", "legend": [{"name": "狹小巷道火災搶救不易地區", "src": "marker_icon/line_red.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_road_new", name: "狹小巷道火災搶救不易地區", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "line_red", field: {'roadname':'路名','roadnum':'路號','width':'道路寬度(m)'}, filter: "width < 4"}); return result;}},
		{"name":"狹小巷道火災搶救不易地區", "data":"狹小巷道火災搶救不易地區", "category":"火災決策", "type":"火災決策", "legend": [{"name": "狹小巷道火災搶救不易地區", "src": "marker_icon/line_red.png"}], method:function(){ var result = narrow_alleys(); ; return result;}},
		{"name":"高危險建築物-點位圖", "data":"高危險建築物-點位圖", "category":"火災決策", "type":"火災決策", "legend": [{"name": "高危險建築物", "src": "marker_icon/dangerous_buildings.png"}], method: function(){ var result = dangerous_buildings_cluster(); return result}},
		{"name":"高危險建築物-熱度圖", "data":"高危險建築物-熱度圖", "category":"火災決策", "type":"火災決策", "legend": [], method: function(){ var result = dangerous_buildings_heatmap(); return result}},
		{"name":"毒化物與其他化學品-點位圖", "data":"毒化物與其他化學品-點位圖", "category":"火災決策", "type":"火災決策", "legend": [{"name": "毒化物與其他化學品", "src": "marker_icon/chemical.png"}], method: function(){ var result = chemicals_cluster(); return result}},
		{"name":"毒化物與其他化學品-熱度圖", "data":"毒化物與其他化學品-熱度圖", "category":"火災決策", "type":"火災決策", "legend": [], method: function(){ var result = chemicals_heatmap(); return result}},
		{"name":"抽水站", "data":"抽水站", "category":"情資", "type":"防救設施", "legend": [{"name": "抽水運作", "src": "marker_icon/pump_r.png"}, {"name": "抽水待機", "src": "marker_icon/pump_g.png"}], method:function(){ var result = pump_wrs(); return result;}},
		{"name":"移動抽水機", "data":"移動抽水機", "category":"情資", "type":"防救設施", "legend": [{"name": "抽水車運作", "src": "marker_icon/pump_car_r.png"}, {"name": "抽水車待命", "src": "marker_icon/pump_car_g.png"}, {"name": "抽水車移動", "src": "marker_icon/pump_car_b.png"}, {"name": "抽水車離線", "src": "marker_icon/pump_car_y.png"}, {"name": "抽水車故障", "src": "marker_icon/pump_car_grey.png"}], method:function(){ var result = moving_car_wrs(); return result;}},
		{"name":"橫移門", "data":"橫移門", "category":"情資", "type":"防救設施", "legend": [{"name": "橫移門開", "src": "marker_icon/gate_g.png"}, {"name": "橫移門關", "src": "marker_icon/gate_r.png"}], method:function(){ var result = waterdoor_status(); return result;}},
		{"name":"重要水庫", "data":"重要水庫", "category":"情資", "type":"防救設施", "legend": [{"name": "水庫與分洪", "src": "marker_icon/dam_g.png"}], method:function(){ var result = reservior_status(); return result;}},
		{"name":"員山子分洪", "data":"員山子分洪", "category":"情資", "type":"防救設施", "legend": [{"name": "水庫與分洪", "src": "marker_icon/dam_g.png"}], method:function(){ var result = diviflow_status(); return result;}},
		{"name":"NCDR歷史淹水點位(109~113年)", "data":"歷史淹水點位NCDR", "category":"情資", "type":"歷史災害", "legend": [{"name": "歷史淹水點位", "src": "marker_icon/circle_一.png"}], method: function(){ var result = layer_history_flood_points(); return result;}},
		{"name":"NCDR歷史淹水範圍(109~113年)", "data":"歷史淹水範圍NCDR", "category":"情資", "type":"歷史災害", "legend": [], method: function(){ var result = layer_history_flood_area(); return result;}},
		{"name":"消防栓", "data":"消防栓", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "消防栓", "src": "marker_icon/fire_hydrant.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:pubpipe_firehydrant", name: "消防栓", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "fire_hydrant", field: {'pipeid':'代碼','pipelength':'長度','pipewidth':'寬度','pmaterial':'材質','builddate':'建造時間'}}); return result;}},
		{"name":"路燈", "data":"路燈", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "路燈", "src": "marker_icon/street_lamp.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:pubpipe_streetlamp", name: "路燈", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "street_lamp", field: {'ID':'路燈編號','TOWN':'區別','AD_SYMBLE':'地標','AD_LINE':'地點描述','AD_RNO':'路燈地址','HEIGHT':'高度','LAMP_TYPE':'燈泡種類','CASE_TYPE':'路燈型式','LAMP_POWER':'燈泡瓦數','LAMP_NOS':'燈泡數量'}}); return result;}},
		{"name":"易淹水通報點位", "data":"易淹水通報點位", "category":"情資", "type":"歷史災害", "legend": [{"name": "易淹水通報點位", "src": "marker_icon/flood_hotspot.png"}], method:function(){ var result = flood_hotspot(); return result;}},
		{"name":"歷史淹水熱度圖", "data":"歷史淹水熱度圖", "category":"情資", "type":"歷史災害", "legend": [{"name": "熱區強度", "src": "marker_icon/hotspot.png", "width": "100%"}], method:function(){ var result = flood_history_event(); return result;}},
		{"name":"歷史淹水範圍", "data":"歷史淹水範圍", "category":"情資", "type":"歷史災害", "legend": [], method:function(){ var result = flood_history_wrap(); return result;}},
		{"name":"淹水易致災村里", "data":"淹水易致災村里", "category":"情資", "type":"歷史災害", "legend": [], method:function(){ var result = history_flood_village(); return result;}},
	    {"name":"土壤液化潛勢圖", "data":"土壤液化潛勢圖", "category":"情資", "type":"災害潛勢", "legend": [{"name": "土壤液化潛勢", "src": "Legend/liquefaction.png", "width": "100%"}], method:function(){ var result = liquefaction_cgs(); return result;}},
		{"name":"近期有感地震", "data":"近期有感地震", "category":"情資", "type":"地震災害", "legend": [{"name": "震央點", "src": "marker_icon/earthquake_center.png"}, {"name": "震度值", "src": "marker_icon/earthquake_station.png"}], method:function(){ var result = earthquake_alert(); return result;}},
		{"name":"山腳斷層", "data":"山腳斷層", "category":"情資", "type":"地震災害", "legend": [{"name": "山腳斷層", "src": "marker_icon/line_white.png"}], method:function(){ var result = earthquake_fault_line(); return result;}},
		{"name":"國震衝擊評估(道路)", "data":"國震衝擊評估(道路)", "category":"情資", "type":"地震災害", "legend": [], method:function(){ var result = layer_ncree_earthquake_damege(); return result;}},
	    {"name":"山坡地風險社區", "data":"山坡地風險社區", "category":"情資", "type":"坡地災害", "legend": [{"name": "山坡地社區-低風險", "src": "marker_icon/hillslope_community_g.png"}, {"name": "山坡地社區-中風險", "src": "marker_icon/hillslope_community_y.png"}, {"name": "山坡地社區-高風險", "src": "marker_icon/hillslope_community_r.png"}], method:function(){ var result = hillslope_community_layer(); return result;}},
		{"name":"坪林分隊水保觀測", "data":"坪林分隊水保觀測", "category":"情資", "type":"坡地災害", "legend": [{"name": "坪林分隊水保觀測", "src": "marker_icon/hillslope_community_g.png"}], method:function(){ var result = hillslope_pinlin_construction_layer(); return result;}},
	    {"name":"九份地滑監測", "data":"九份地滑監測", "category":"情資", "type":"坡地災害", "legend": [{"name": "九份地滑監測", "src": "marker_icon/underground_green.png"}, {"name": "九份地滑監測警戒", "src": "marker_icon/underground_red.png"}], method:function(){ var result = jiufen_sensor_layer(); return result;}},
		{"name":"學校單位", "data":"學校單位", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "學校單位", "src": "marker_icon/school.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_school_earthquake", name: "學校單位", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "school", field: {'name':'學校名稱','address':'地址','region':'所屬行政區','potential':'地震風險等級','descriptio':'地震補充說明'}}); return result;}},
		{"name":"醫院單位", "data":"醫院單位", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "醫護相關", "src": "marker_icon/vulnerable.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_hospital", name: "醫院單位", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "hospital", field: {'name':'機構名稱','no':'機構代碼','district':'行政區','address':'地址','telephone':'電話'}}); return result;}},
		{"name":"一般護理之家", "data":"一般護理之家", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "醫護相關", "src": "marker_icon/vulnerable.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_care_normal", name: "一般護理之家", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "hospital", field: {'title':'機構名稱','address':'地址','name':'負責人','tel':'電話','bed':'開放床數','number':'機構應配置護理人員數'}}); return result;}},
		{"name":"產後護理之家", "data":"產後護理之家", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "醫護相關", "src": "marker_icon/vulnerable.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_care_pregnant", name: "產後護理之家", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "hospital", field: {'title':'機構名稱','address':'地址','name':'負責人','tel':'電話','bed_for_pregnant':'產後護理床開放數','bed_for_babies':'嬰兒床開放數','number':'機構應配置護理人員數'}}); return result;}},
		{"name":"健保署特約藥局", "data":"健保署特約藥局", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "醫護相關", "src": "marker_icon/vulnerable.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_drug_store", name: "健保署特約藥局", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "hospital", field: {'tel':'電話','name':'藥局名稱','address':'地址','region':'所屬行政區'}}); return result;}},
		{"name":"救護車營業機構", "data":"救護車營業機構", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "醫護相關", "src": "marker_icon/vulnerable.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_ambulance", name: "救護車營業機構", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "hospital", field: {'no':'機構代碼','name':'機構名稱','telephone':'電話','address':'地址'}}); return result;}},
		{"name":"重要橋樑", "data":"重要橋樑", "category":"情資", "type":"防救設施", "legend": [{"name": "重要橋樑", "src": "marker_icon/bridge.png"}], method:function(){ var result = important_bridge(); return result;}},
		{"name":"重要道路", "data":"重要道路", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "重要道路", "src": "marker_icon/line_black.png"}], method:function(){ var result = wmsTileLayerCreate(publicPath + "/cloud/geoserver/edp3/wms?", { layer: "edp3:ntc_road_new", name: "重要道路", geoFieldName: "geom", method: {name: "geojson"}, pane: "high-zindex-wms-layer", style: "line_black", field: {'roadname':'路名','roadnum':'路號'}}); return result;}},
		{"name":"農路圖", "data":"農路圖", "category":"情資", "type":"防救設施", "mapType": "WMS", "legend": [{"name": "農路圖", "src": "marker_icon/line_brown.png"}], method:function(){ var result = farm_road_swcb(); return result;}},
		{"name":"電力管線", "data":"電力管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "電力管線", "src": "marker_icon/line_orange.png"}], method:function(){ var result = get_ntpcgis_electricity_pipeline(); return result;}},
		{"name":"瓦斯管線", "data":"瓦斯管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "瓦斯管線", "src": "marker_icon/line_darkred.png"}], method:function(){ var result = get_ntpcgis_gas_pipeline(); return result;}},
		{"name":"供氣系統開關閥", "data":"瓦斯管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "供氣系統開關閥", "src": "marker_icon/gas_switch.png"}], method:function(){ var result = get_ntpcgis_gas_pipe_valve(); return result;}},
		{"name":"供氣系統其他設施", "data":"瓦斯管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "供氣系統其他設施", "src": "marker_icon/gas_other.png"}], method:function(){ var result = get_ntpcgis_gas_pipe_other(); return result;}},
		{"name":"供氣系統場站", "data":"瓦斯管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "供氣系統場站", "src": "marker_icon/gas_station.png"}], method:function(){ var result = get_ntpcgis_gas_pipe_station(); return result;}},
		{"name":"瓦斯孔蓋", "data":"瓦斯孔蓋", "category":"情資", "type":"維生管線", "legend": [{"name": "瓦斯孔蓋-圓孔", "src": "marker_icon/letter-g.png"}, {"name": "瓦斯孔蓋-方孔", "src": "marker_icon/letter-g-square.png"}], method:function(){ var result = get_ntpcgis_gas_pipe_manhole(); return result;}},
		{"name":"電信管線", "data":"電信管線", "category":"情資", "type":"維生管線", "legend": [{"name": "電信管線", "src": "marker_icon/line_green.png"}], method:function(){ var result = get_ntpcgis_telecom_pipeline(); return result;}},
		{"name":"自來水管線", "data":"自來水管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "自來水管線", "src": "marker_icon/line_skyblue.png"}], method:function(){ var result = get_ntpcgis_water_pipeline(); return result;}},
		{"name":"輸油管線", "data":"輸油管線", "category":"情資", "type":"維生管線", "mapType": "WMS", "legend": [{"name": "輸油管線", "src": "marker_icon/line_purple.png"}], method:function(){ var result = get_ntpcgis_oil_pipeline(); return result;}},
		{"name":"火災熱區-住警器", "data":"火災熱區-住警器", "category":"情資", "type":"火災災害", "legend": [{"name": "火災熱區-住警器", "src": "marker_icon/square_red.png"}], method:function(){ var result = overlayMaps["火災熱區-住警器"]; return result;}},
		{"name":"淹水潛勢Q1", "data":"淹水潛勢Q1", "data_name":"Q001", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q2", "data":"淹水潛勢Q2", "data_name":"Q002", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q5", "data":"淹水潛勢Q5", "data_name":"Q005", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q10", "data":"淹水潛勢Q10", "data_name":"Q010", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q20", "data":"淹水潛勢Q20", "data_name":"Q020", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q25", "data":"淹水潛勢Q25", "data_name":"Q025", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q50", "data":"淹水潛勢Q50", "data_name":"Q050", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q100", "data":"淹水潛勢Q100", "data_name":"Q100", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q200", "data":"淹水潛勢Q200", "data_name":"Q200", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢Q500", "data":"淹水潛勢Q500", "data_name":"Q500", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢R200", "data":"淹水潛勢R200", "data_name":"R200", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢R350", "data":"淹水潛勢R350", "data_name":"R350", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢R450", "data":"淹水潛勢R450", "data_name":"R450", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
	    {"name":"淹水潛勢R600", "data":"淹水潛勢R600", "data_name":"R600", "category":"情資", "type":"災害潛勢", "legend": [{"name": "淹水深度", "src": "Legend/prediction_depth.png", "width": "100%"}], method:function(){ var result = flood_potential_wrap(this.data_name); return result;}},
		{"name":"火山(小油坑)", "data":"火山(小油坑)", "category":"情資", "type":"災害潛勢", "legend": [{"name": "火山熔岩流", "src": "Legend/square_red.png"}, {"name": "火山碎屑流", "src": "Legend/square_brown.png"}, {"name": "火山灰-夏季", "src": "Legend/line_yellow.png"}, {"name": "火山灰-冬季", "src": "Legend/line_blue.png"}], method:function(){ var result = volcano_layer(this.name, "volcano_small_oil.json"); return result;}},
		{"name":"火山(大油坑)", "data":"火山(大油坑)", "category":"情資", "type":"災害潛勢", "legend": [{"name": "火山熔岩流", "src": "Legend/square_red.png"}, {"name": "火山碎屑流", "src": "Legend/square_brown.png"}, {"name": "火山灰-夏季", "src": "Legend/line_yellow.png"}, {"name": "火山灰-冬季", "src": "Legend/line_blue.png"}], method:function(){ var result = volcano_layer(this.name, "volcano_big_oil.json"); return result;}},
		{"name":"火山(七星山)", "data":"火山(七星山)", "category":"情資", "type":"災害潛勢", "legend": [{"name": "火山熔岩流", "src": "Legend/square_red.png"}, {"name": "火山碎屑流", "src": "Legend/square_brown.png"}, {"name": "火山灰-夏季", "src": "Legend/line_yellow.png"}, {"name": "火山灰-冬季", "src": "Legend/line_blue.png"}], method:function(){ var result = volcano_layer(this.name, "volcano_7_star.json"); return result;}},
	]

	// 即時消防人力資源戰情系統 各大隊連結
	const powerBILink = {
		brigade_1: 'https://app.powerbi.com/reportEmbed?reportId=b072f50a-32fc-4c79-bdff-4f34c414d4c4&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_2: 'https://app.powerbi.com/reportEmbed?reportId=8e04f064-8f5c-4699-adf7-2f757d70c20c&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_3: 'https://app.powerbi.com/reportEmbed?reportId=0ce3786d-2518-4cc0-acdd-23a0fc41b34a&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_4: 'https://app.powerbi.com/reportEmbed?reportId=06df78c8-5f24-4bc0-9074-9730183143b4&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_5: 'https://app.powerbi.com/reportEmbed?reportId=8d6fe4ff-7f93-434f-8947-8d9eeff9cd31&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_6: 'https://app.powerbi.com/reportEmbed?reportId=962905ee-dd65-4e3a-ab4d-3a9c3e8681e4&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
		brigade_7: 'https://app.powerbi.com/reportEmbed?reportId=25dce6cb-8f7b-460b-b2e0-a36788e2aa53&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1',
	}
	var powerBILinkHtml = ''
	Object.values(powerBILink).forEach(function(href, index){
		powerBILinkHtml += `<a class="dropdown-item" target="_blank" href="${href}">第 ${index+1} 大隊</a>`
	})
	powerBILinkHtml += `<a class="dropdown-item" target="_blank"
		href="https://app.powerbi.com/reportEmbed?reportId=c9a623df-de0a-4ba9-a607-a42ce5efebd5&autoAuth=true&ctid=cc88fbe4-a9e5-4731-9d3f-f70b309270e1">
		特搜大隊
	</a>`


	// 使用者身分確認
	$.ajax({
		url: publicPath + '/napi/account_manage/get_role_func',
		method: 'GET',
		async: false,
		headers: {
			Authorization: 'Bearer ' + jwt_token
		}
	}).done(function(res) {
		var status = res.data[0],
			ignoreList = ["id", "name"]
		if (!status.warning_theme) {
			status.cctv = false
		}
		Object.keys(status).forEach(function(key){
			if (!ignoreList.includes(key)) {
				var btnSetting = status[key]
				if (key == "police_cctv") {
					if (btnSetting) {
						overlay_list.splice(26, 0, {"name":"警察局CCTV", "data":"警察局CCTV", "category":"情資", "type":"防救設施", "legend": [{"name": "警察局", "src": "marker_icon/cctv_police.png"}], method:function(){ var result = cctv_police(map); return result;}});
					}
				} else {
					if (!btnSetting) {
						$('.btn-control[functionName="' + key + '"]').each(function(){
							var target = $(this).attr("settingType")
							switch(target){
								case "alert":
									$(this).unbind().click(function(event){
										alert("此功能因權限不足，而無法檢視。")
										event.preventDefault();
									})
									break
								case "id":
									$(this).attr("id", "")
									break
								case "unbind":
									$(this).unbind()
									break
								case "render":
									$(this).html('<div class="text-center m-3">此功能因權限不足，而無法檢視。</div>')
									break
							}
						})
					}
				}
			}
		})
		switch (status.name) {
			case "管理者":
			case "消防局主辦科":
				$("#trainingDropdown").html(`
					<a class="dropdown-item" target="_blank" href="https://drive.google.com/drive/u/1/folders/1ktpnf1Dt7XfgFD1b3zkpZGk1fqK7bbBT">操作影片範例</a>
					<a class="dropdown-item" target="_blank" href="../api/全災型智慧化指揮監控平臺-教育訓練114年版.pdf">系統操作手冊</a>
				`)
				$("#backPlatformDropdown").html(`
					<a class="dropdown-item" target="_blank" href="../apiobs">API監控與分析平臺</a>
					<a class="dropdown-item" target="_blank" href="${publicPath}/apply">API管控與申請平臺</a>
					<a class="dropdown-item" target="_blank" href="${publicPath}/">使用者登入統計功能</a>
					<a class="dropdown-item" target="_blank" href="${publicPath}/manage">使用者權限管控平臺</a>
				`)
				$("#etlPlatformDropdown").html(`
					<a class="dropdown-item" target="_blank" href="${publicPath}/etl">倉儲即時監控模組</a>
					<a class="dropdown-item p-cursor" id="t_swagger">Open API文件</a>
					<a class="dropdown-item p-cursor" id="t_edpw_obs">資料監控平臺</a>
					<a class="dropdown-item" target="_blank" href="${publicPath}/datalake/">資料湖泊全文檢索系統</a>
					<a class="dropdown-item btn-link dropdown-toggle text-dark text-decoration-none"
						href="#" role="button" data-toggle="dropdown">即時消防人力資源戰情系統
					</a>
					<div class="dropdown-menu shadow-lg" id="powerBIDropdown"></div>
				`)
				$("#powerBIDropdown").html(powerBILinkHtml)

				break
			case "消防局其他人員":
			case "新北市公務人員":
				$("#trainingDropdown").html(`
					<a class="dropdown-item" target="_blank" href="https://drive.google.com/drive/u/1/folders/1ktpnf1Dt7XfgFD1b3zkpZGk1fqK7bbBT">操作影片範例</a>
					<a class="dropdown-item" target="_blank" href="../api/全災型智慧化指揮監控平臺-教育訓練114年版.pdf">系統操作手冊</a>
				`)
				$("#backPlatformDropdown").html('<a class="dropdown-item p-cursor" id="t_swagger"> Open API文件 </a>')
				break
		}
	})
	overlay_list.forEach(function(element){
		var checkbox_string = '<td class="text-center p-0" style="width: 32px;"><input type="checkbox"></td>',
			input_check = $(
				'<tr class="scale_target" id="' + element.name + '">' +
					'<td class="d-none">' + element.category +'</td>' +
					'<td>' + element.type +'</td>' +
					checkbox_string +
					'<td>' + element.name + '</td>' +
				'</tr>'
			)
		input_check.click(function(event){
			var condition = $(this).find("input").prop("checked")
			if (event.target.nodeName != "INPUT") {
				if (condition) {
					$(this).find("input").prop('checked', false)
				} else {
					$(this).find("input").prop('checked', true)
				}
				condition = $(this).find("input").prop("checked")
			}
			if(condition) {
				try {
					if (element.name == "重大災情" || element.name == "一般災情") {
						overlay_dataset[element.data].addTo(map);
					} else {
						var this_return = element.method();
						if (this_return) {
							switch(this_return[0]){
								case undefined:
									overlay_dataset[element.data] = this_return;
									overlay_dataset[element.data].addTo(map);
									break;
								default:
									overlay_dataset[element.data] = this_return[0];
									overlay_dataset[element.data].addTo(map);
									raw_data[element.data] = this_return[1];
							}
						}
					};
					var legend_html = "";
					switch(true){
						case (element.legend == undefined):
							break;
						case (element.legend != undefined):
							element.legend.forEach(function(this_lengend){
								var legend_survival = $("#legend_tag_" + this_lengend.name).html();
								if (legend_survival == undefined) {
									if (this_lengend.width == undefined) {
										this_lengend.width = "32";
									}
									legend_html +=
										'<div id="legend_tag_' + this_lengend.name + '" class="legend_text">' +
											this_lengend.name + '<br>' +
											'<img src="' + this_lengend.src + '" width="' + this_lengend.width +'">' +
										'</div>';
								} else {
									$("#legend_tag_" + this_lengend.name).css("display", "block");
								}
							});
							$("#legend_div_container").append(legend_html);
							break;
					}
					if(element.mapType == "WMS"){
						if (map._events.click) {
							var wmsTileLayerInfoClick = map._events.click.filter(function(element){
								return element.name == "wmsTileLayerInfo"
							})
							if (wmsTileLayerInfoClick.length == 0) {
								map.on("click", wmsTileLayerInfo)
							}
						} else {
							map.on("click", wmsTileLayerInfo)
						}
					}
				} catch (e) {
					console.log(e)
					toast_open('API介接異常，導致系統錯誤。')
					loader_animation_control(false)
				}
			} else {
				map.removeLayer(overlay_dataset[element.data]);
				if (element.name == "重大災情" || element.name == "一般災情") {

				} else {
					delete overlay_dataset[element.data];
				};
				switch(true){
					case (element.legend == undefined):

						break;
					case (element.legend != undefined):
						element.legend.forEach(function(this_lengend){
							$("#legend_tag_" + this_lengend.name).css("display", "none");
						});
						break;
				}
				if(element.mapType == "WMS"){
					wmsQueryTargetList = wmsQueryTargetList.filter(function(eachWMS){
						return eachWMS.option.name != element.name
					})
				}
			}
		});
		$('#over_layer tbody').append(input_check);
	})
	layerTableInitial(true)
	function layerTableInitial(first){
		if (!first) {
			$('#ovarlay_list').DataTable().destroy()
		}
		$('#ovarlay_list').DataTable({
			"searching": true,
			"info": false,
			"paging": false,
			"ordering": false,
			"scrollY": ($(window).height()-430) + "px",
			"scrollCollapse": true
		});
		$('#ovarlay_list_wrapper').find(".dataTables_scrollBody").addClass("mostly-customized-scrollbar");
		$('#ovarlay_list_wrapper').find(".dataTables_scrollHeadInner").addClass("w-100");
	}

	// map setting
	var scale = $('.leaflet-control-scale-line:eq(0)').detach();
	$("#topright_div").append(scale);
	// control sliderbar width
	var dragging = false;
   	$('#dragbar').mousedown(function(e){
        e.preventDefault();
        dragging = true;
        var main = $('.panel');
        var ghostbar = $(
       		'<div>',
            {id:'ghostbar',
             css: {
                    height: main.outerHeight(),
                    top: main.offset().top,
                    left: main.offset().right
                }
            }).appendTo('body');
        $(document).mousemove(function(e){
            ghostbar.css("left",e.pageX+2);
       });
    });
    $(document).mouseup(function(e){
        if(dragging){
	        var percentage = (e.pageX / window.innerWidth) * 100;
	        var mainPercentage = 100-percentage;
	        $('.panel').css("width",percentage + "%");
	        $('#ghostbar').remove();
	        $(document).unbind('mousemove');
	        dragging = false;
	        marquee_adjust_position();
			highchart_reflow();
			resetLegendDivPosititon("open")
        }
    });
    $(".nav.nav-tabs").click(function(){
    	setTimeout(function(){
	    	highchart_reflow();
		}, 1000);
    })
	// common function
	$("#legend_div_control").click(function(){
		$("#legend_div_container").toggle()
		switch ($("#legend_div_container").css("display")) {
			case "block":
				$(this).find("span").html('<i class="fas fa-angle-down"></i>')
				break
			case "none":
				$(this).find("span").html('<i class="fas fa-angle-up"></i>')
				break
		}
	})
	$("#menu_bar .nav-link").click(function(){
		var from = $(this).attr("id")
		if (from != "main-4") {
			$("#topic-quick-dropdown").css("display", "none")
		}
	})
	$(window).resize(function(e){
		layerTableInitial(false)
		var condition = $("#siderbar").css("display");
		if (condition) {
			var screen_w = $("#siderbar").width();
			$("#legend_div").css("left", (parseInt(screen_w) + 5) + "px");
		}
	})
	function resetLegendDivPosititon (action) {
		switch (action) {
			case "open":
				var silderPanelWidth = $("#siderbar").width()
				$("#legend_div").css({
					"top": "5px",
					"left": (silderPanelWidth + 5) + "px",
					"max-height": "calc( 100vh - 5px )"
				})
				break
			case "close":
				$("#legend_div").css({
					"top": "50px",
					"left": "unset",
					"max-height": "calc( 100vh - 50px )"
				})
				break
		}
	}
	$("body").on("click", ".modal-img", function(){
        var url = $(this).attr('src');
        modal_open('<img class="w-100" src="' + url + '">');
	})
	var lastBtnTarget, ignoreBtnTarget = ["9", "10", "11", "12", "13", "14", "15", "16", "17"]
	$("body").on("click", ".function-log", function(){
		var targetId = $(this).attr('function-log-id');
		if (targetId != "") {
			if (lastBtnTarget != targetId) {
				// handle 預警監控(右上角)
				if (ignoreBtnTarget.includes(targetId) && !ignoreBtnTarget.includes(lastBtnTarget) && lastBtnTarget != "4") {
					$.ajax({
						url: publicPath + '/napi/account_manage/func_log',
						type: 'POST',
						headers: {
							Authorization: 'Bearer ' + jwt_token
						},
						data: {
							func_id: parseInt(4)
						}
					})
				}
				// formal
				if ((targetId == "4" && ignoreBtnTarget.includes(lastBtnTarget))) {

				} else {
					$.ajax({
						url: publicPath + '/napi/account_manage/func_log',
						type: 'POST',
						headers: {
							Authorization: 'Bearer ' + jwt_token
						},
						data: {
							func_id: parseInt(targetId)
						}
					})
					lastBtnTarget = targetId
				}
			}
		}
	})
	$('body').on('click', '.table-zoom-town-region tbody tr', function(){
		var target = $(this).attr('town-name')
		overlay_dataset["Basic_map"].features.forEach(function(feature){
			if (feature.properties['TOWNNAME'] == target) {
				map.fitBounds(L.geoJson(feature).getBounds())
			}
		})
	})
	$("body").on("click", ".cctv-new-window", function(){
		var dialog_name = $(this).attr("url-name")
		var url_string = $(this).attr("url-target")
		var url_type = $(this).attr("url-type")
		let is_police = $(this).attr("is-police")

		console.log(isMobile)
		if (isMobile) {
			cctv_modal(dialog_name, url_string, url_type, is_police)
		} else {
			cctv_dialog(dialog_name, url_string, url_type, is_police)
		}
	})
	$("body").on("click", ".cctv-group-window", function(){
		if (cctv_render_list.length < 6) {
			let station_name = $(this).attr("url-name")
			let url_string = $(this).attr("url-target")
			let url_type = $(this).attr("url-type")
			let is_police = $(this).attr("is-police")

			if (cctv_render_list.map(el => el.url_string).includes(url_string)) {
				alert('此CCTV已存在於CCTV群組。')
				return
			}
			cctv_render_list.push({station_name, url_string, url_type})
			cctv_render_list.forEach((el, index) => {
				cctv_group_append(el.station_name, el.url_string, el.url_type, index+1, is_police)
			})
			for (let i = 0; i < 6; i++) {
				(i+1) > cctv_render_list.length
					? $("#cctv-order-" + (i+1) + ' button').addClass('d-none')
					: $("#cctv-order-" + (i+1) + ' button').removeClass('d-none')
			}
			topic_cctv()
			localStorage.setItem('cctv_render_list', JSON.stringify(cctv_render_list))
			alert(`已成功將「${station_name}」加入CCTV群組，剩餘空位: ${6-cctv_render_list.length}。`)
		} else {
			alert('CCTV群組容量已滿，請先關閉部分CCTV。')
		}
	})
	$("body").on("click", ".point-google-street", function(){
		var url_string = "https://maps.google.com/maps?q=&layer=c&cbll=" + $(this).attr("lat") + "," + $(this).attr("lon") + "&cbp=12,270";
		window.open(url_string, '_blank');
	})

	map.off("click")
})
